/**
 * Secure System Health Dashboard
 * 
 * Production-ready version with admin-only access control
 */

import React from 'react';
import AdminOnlyWrapper from './AdminOnlyWrapper';
import SystemHealthDashboard from './SystemHealthDashboard';

interface SecureSystemHealthDashboardProps {
    userId?: string;
    tenantId?: string;
}

export const SecureSystemHealthDashboard: React.FC<SecureSystemHealthDashboardProps> = ({ userId, tenantId }) => {
    return (
        <AdminOnlyWrapper 
            requiredRole="admin or system-admin"
            fallbackMessage="The System Health Dashboard is restricted to administrators only. This tool provides sensitive system information and administrative controls."
        >
            <SystemHealthDashboard />
        </AdminOnlyWrapper>
    );
};

export default SecureSystemHealthDashboard;